// // // //  import React from 'react'

// // // //  const Carreies = () => {
// // // //    return (
// // // //      <div>
// // // //        <h1> this carrire page</h1>
// // // //      </div>
// // // //    )
// // // //  }

// // // //  export default Carreies

// // // import React from "react";
// // // import { motion } from "framer-motion";

// // // const jobs = [
// // //   {
// // //     id: 1,
// // //     title: "Senior Data Analyst",
// // //     location: "Mumbai, India",
// // //     type: "Full-time",
// // //     description:
// // //       "Leverage data to improve client sales strategies and campaign reach. Experience in BFSI or SaaS preferred.",
// // //   },
// // //   {
// // //     id: 2,
// // //     title: "Bilingual Telecalling Executive",
// // //     location: "Remote / Mumbai",
// // //     type: "Contract",
// // //     description:
// // //       "Fluency in English and Hindi required. Handle outbound campaigns targeting Tier-1 & Tier-2 Indian metros.",
// // //   },
// // //   {
// // //     id: 3,
// // //     title: "Customer Success Manager",
// // //     location: "Bangalore, India",
// // //     type: "Full-time",
// // //     description:
// // //       "Drive client engagement and retention across fintech & edtech sectors. Strong consultative skills needed.",
// // //   },
// // // ];

// // // const perks = [
// // //   "Competitive salary packages",
// // //   "Flexible work-from-home options",
// // //   "Comprehensive health coverage",
// // //   "Upskill & learning programs",
// // //   "Inclusive, diverse workplace",
// // //   "Quarterly offsite & team events",
// // // ];

// // // const testimonials = [
// // //   {
// // //     name: "Priya Sharma",
// // //     role: "Lead Data Engineer",
// // //     photo: "https://randomuser.me/api/portraits/women/45.jpg",
// // //     quote:
// // //       "At Augere I get to work with data at Indian scale and see our impact directly on B2B client success.",
// // //   },
// // //   {
// // //     name: "Rajesh Kumar",
// // //     role: "Telecalling Team Lead",
// // //     photo: "https://randomuser.me/api/portraits/men/46.jpg",
// // //     quote:
// // //       "Supportive team, constant innovation, and flexible work-life balance—Augere truly values every employee.",
// // //   },
// // // ];

// // // const containerVariants = {
// // //   hidden: { opacity: 0 },
// // //   visible: {
// // //     opacity: 1,
// // //     transition: { staggerChildren: 0.14, when: "beforeChildren" },
// // //   },
// // // };
// // // const itemVariants = {
// // //   hidden: { opacity: 0, y: 20 },
// // //   visible: { opacity: 1, y: 0 },
// // // };

// // // const Carreies = () => {
// // //   return (
// // //     <div className="bg-gradient-to-b from-blue-900 to-indigo-950 min-h-screen text-white font-sans tracking-tight">
// // //       {/* Hero Section */}
// // //       <section className="relative bg-[url('https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=1470&q=80')] bg-cover bg-center min-h-[60vh] flex items-center justify-center px-6">
// // //         <div className="bg-black bg-opacity-60 p-10 rounded-lg max-w-3xl text-center shadow-lg">
// // //           <h1 className="text-5xl font-extrabold mb-5 font-serif drop-shadow-lg">
// // //             Careers at Augere Strategies
// // //           </h1>
// // //           <p className="text-xl max-w-xl mx-auto text-blue-100 mb-6">
// // //             Join a pioneering Indian B2B company turning data into business
// // //             growth. We seek curious, ambitious talent across engineering, sales,
// // //             support, and analytics.
// // //           </p>
// // //           <a
// // //             href="#openings"
// // //             className="inline-block mt-2 px-7 py-3 bg-yellow-400 text-blue-900 font-bold rounded-md shadow-lg hover:bg-yellow-300 transition"
// // //           >
// // //             View Open Positions
// // //           </a>
// // //         </div>
// // //       </section>

// // //       {/* Open Jobs Section */}
// // //       <motion.section
// // //         id="openings"
// // //         className="max-w-7xl mx-auto py-20 px-6"
// // //         variants={containerVariants}
// // //         initial="hidden"
// // //         whileInView="visible"
// // //         viewport={{ once: true }}
// // //       >
// // //         <h2 className="text-4xl font-bold text-yellow-400 mb-12 text-center font-serif">
// // //           Open Positions
// // //         </h2>
// // //         <div className="grid md:grid-cols-3 gap-9">
// // //           {jobs.map((job) => (
// // //             <motion.div
// // //               key={job.id}
// // //               className="bg-white bg-opacity-10 backdrop-blur-xl rounded-xl p-7 flex flex-col shadow-md"
// // //               variants={itemVariants}
// // //               whileHover={{
// // //                 scale: 1.05,
// // //                 boxShadow: "0 12px 32px rgba(255, 219, 77, 0.15)",
// // //               }}
// // //             >
// // //               <h3 className="text-xl font-bold mb-1">{job.title}</h3>
// // //               <p className="text-yellow-300 font-medium mb-1">
// // //                 {job.location} <span className="mx-1">|</span> {job.type}
// // //               </p>
// // //               <p className="text-gray-300 mb-4 flex-grow">{job.description}</p>
// // //               <a
// // //                 href="#apply"
// // //                 className="mt-auto inline-block font-semibold bg-yellow-400 text-blue-900 px-5 py-2 rounded hover:bg-yellow-300 transition w-fit"
// // //               >
// // //                 Apply Now
// // //               </a>
// // //             </motion.div>
// // //           ))}
// // //         </div>
// // //       </motion.section>

// // //       {/* Perks & Benefits */}
// // //       <section className="py-20 bg-blue-800">
// // //         <div className="max-w-5xl mx-auto px-6 text-center">
// // //           <h2 className="text-4xl font-bold text-yellow-400 mb-10 font-serif">
// // //             Why Work With Us?
// // //           </h2>
// // //           <ul className="max-w-xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-y-6 gap-x-14 text-yellow-200 text-lg font-medium">
// // //             {perks.map((perk, i) => (
// // //               <li key={i} className="flex items-center justify-center">
// // //                 <span className="mr-2 text-2xl">✔️</span> {perk}
// // //               </li>
// // //             ))}
// // //           </ul>
// // //         </div>
// // //       </section>

// // //       {/* Application Workflow */}
// // //       <section
// // //         id="apply"
// // //         className="max-w-6xl mx-auto py-20 px-6 text-center text-white"
// // //       >
// // //         <h2 className="text-4xl font-bold mb-12 font-serif">How to Apply</h2>
// // //         <div className="max-w-3xl mx-auto grid grid-cols-1 sm:grid-cols-3 gap-12">
// // //           <motion.div
// // //             initial={{ opacity: 0, y: 40 }}
// // //             whileInView={{ opacity: 1, y: 0 }}
// // //             transition={{ duration: 0.5, delay: 0.1 }}
// // //             className="bg-blue-700 rounded-xl p-6"
// // //           >
// // //             <span className="text-6xl mb-3 block">1</span>
// // //             <h3 className="text-lg mb-1 font-semibold">Browse Jobs</h3>
// // //             <p className="text-blue-300 text-base">
// // //               See all current open roles and pick one that matches your
// // //               expertise.
// // //             </p>
// // //           </motion.div>
// // //           <motion.div
// // //             initial={{ opacity: 0, y: 40 }}
// // //             whileInView={{ opacity: 1, y: 0 }}
// // //             transition={{ duration: 0.5, delay: 0.28 }}
// // //             className="bg-blue-700 rounded-xl p-6"
// // //           >
// // //             <span className="text-6xl mb-3 block">2</span>
// // //             <h3 className="text-lg mb-1 font-semibold">Send Your CV</h3>
// // //             <p className="text-blue-300 text-base">
// // //               Email us your updated resume describing your passion and skills.
// // //             </p>
// // //           </motion.div>
// // //           <motion.div
// // //             initial={{ opacity: 0, y: 40 }}
// // //             whileInView={{ opacity: 1, y: 0 }}
// // //             transition={{ duration: 0.5, delay: 0.42 }}
// // //             className="bg-blue-700 rounded-xl p-6"
// // //           >
// // //             <span className="text-6xl mb-3 block">3</span>
// // //             <h3 className="text-lg mb-1 font-semibold">Interview & Join</h3>
// // //             <p className="text-blue-300 text-base">
// // //               If shortlisted, attend interviews and join India’s most dynamic
// // //               B2B team!
// // //             </p>
// // //           </motion.div>
// // //         </div>
// // //       </section>

// // //       {/* Employee Testimonials */}
// // //       <section className="py-20 bg-gradient-to-b from-indigo-900 to-blue-900">
// // //         <div className="max-w-6xl mx-auto px-6">
// // //           <h2 className="text-4xl text-yellow-400 font-bold text-center font-serif mb-12">
// // //             Employee Stories
// // //           </h2>
// // //           <div className="grid md:grid-cols-2 gap-10">
// // //             {testimonials.map(({ name, role, photo, quote }, i) => (
// // //               <motion.div
// // //                 key={i}
// // //                 initial={{ opacity: 0, y: 30 }}
// // //                 whileInView={{ opacity: 1, y: 0 }}
// // //                 transition={{ duration: 0.5, delay: i * 0.2 }}
// // //                 className="bg-blue-800 bg-opacity-80 rounded-xl p-8 shadow-lg flex items-center gap-6"
// // //               >
// // //                 <img
// // //                   src={photo}
// // //                   alt={`${name}, ${role}`}
// // //                   className="w-20 h-20 rounded-full object-cover border-4 border-yellow-400"
// // //                 />
// // //                 <div>
// // //                   <p className="mb-3 italic text-blue-100">"{quote}"</p>
// // //                   <p className="font-bold text-yellow-400">{name}</p>
// // //                   <p className="text-blue-300">{role}</p>
// // //                 </div>
// // //               </motion.div>
// // //             ))}
// // //           </div>
// // //         </div>
// // //       </section>

// // //       {/* CTA */}
// // //       <section className="bg-yellow-400 py-16 text-blue-900 text-center font-bold text-xl tracking-wide hover:text-yellow-600 transition">
// // //         <a href="mailto:careers@augereconversion.com" className="underline">
// // //           Ready to join? Email your CV to careers@augereconversion.com
// // //         </a>
// // //       </section>
// // //     </div>
// // //   );
// // // };

// // // export default Carreies;

// // import React from "react";
// // import { motion } from "framer-motion";

// // const jobs = [
// //   {
// //     id: 1,
// //     title: "Senior Data Analyst",
// //     location: "Mumbai/Pune, India (Remote)",
// //     type: "Full-time",
// //     description:
// //       "Leverage data to improve client sales strategies and campaign reach. Experience in BFSI or SaaS preferred.",
// //   },
// //   {
// //     id: 2,
// //     title: "Bilingual Telecalling Executive",
// //     location: "Mumbai/Pune, India (Remote)",
// //     type: "Contract",
// //     description:
// //       "Fluency in English and Hindi required. Handle outbound campaigns targeting Tier-1 & Tier-2 Indian metros.",
// //   },
// //   {
// //     id: 3,
// //     title: "Data Researcher",
// //     location: "Remote (Global)",
// //     type: "Full-time",
// //     description:
// //       "Collect, analyze, and interpret complex datasets from various sources for our global client base.",
// //   },
// // ];

// // const perks = [
// //   "Competitive salary packages",
// //   "Remote-first work culture",
// //   "Home office setup allowance",
// //   "Global health and wellness programs",
// //   "Online professional development",
// //   "Flexible working hours",
// // ];

// // const testimonials = [
// //   {
// //     name: "Priya Sharma",
// //     role: "Lead Data Engineer",
// //     photo: "https://randomuser.me/api/portraits/women/45.jpg",
// //     quote:
// //       "At Augere I get to work with data at Indian scale and see our impact directly on B2B client success.",
// //   },
// //   {
// //     name: "Rajesh Kumar",
// //     role: "Telecalling Team Lead",
// //     photo: "https://randomuser.me/api/portraits/men/46.jpg",
// //     quote:
// //       "Supportive team, constant innovation, and flexible work-life balance—Augere truly values every employee.",
// //   },
// // ];

// // const containerVariants = {
// //   hidden: { opacity: 0 },
// //   visible: {
// //     opacity: 1,
// //     transition: { staggerChildren: 0.14, when: "beforeChildren" },
// //   },
// // };
// // const itemVariants = {
// //   hidden: { opacity: 0, y: 20 },
// //   visible: { opacity: 1, y: 0 },
// // };

// // const Carreies = () => {
// //   return (
// //     <div className="bg-gradient-to-b from-blue-900 to-indigo-950 min-h-screen text-white font-sans tracking-tight">
// //       {/* Hero Section */}
// //       <section className="relative bg-[url('https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=1470&q=80')] bg-cover bg-center min-h-[60vh] flex items-center justify-center px-6">
// //         <div className="bg-black bg-opacity-60 p-10 rounded-lg max-w-3xl text-center shadow-lg">
// //           <h1 className="text-5xl font-extrabold mb-5 font-serif drop-shadow-lg">
// //             Careers at Augere Conversion
// //           </h1>
// //           <p className="text-xl max-w-xl mx-auto text-blue-100 mb-6">
// //             Join the Global Data Revolution - From Anywhere. We're redefining the landscape of
// //             data-driven solutions through our innovative remote-first approach.
// //           </p>
// //           <a
// //             href="#openings"
// //             className="inline-block mt-2 px-7 py-3 bg-yellow-400 text-blue-900 font-bold rounded-md shadow-lg hover:bg-yellow-300 transition"
// //           >
// //             View Open Positions
// //           </a>
// //         </div>
// //       </section>

// //       {/* Open Jobs Section */}
// //       <motion.section
// //         id="openings"
// //         className="max-w-7xl mx-auto py-20 px-6"
// //         variants={containerVariants}
// //         initial="hidden"
// //         whileInView="visible"
// //         viewport={{ once: true }}
// //       >
// //         <h2 className="text-4xl font-bold text-yellow-400 mb-12 text-center font-serif">
// //           Open Positions
// //         </h2>
// //         <div className="grid md:grid-cols-3 gap-9">
// //           {jobs.map((job) => (
// //             <motion.div
// //               key={job.id}
// //               className="bg-white bg-opacity-10 backdrop-blur-xl rounded-xl p-7 flex flex-col shadow-md"
// //               variants={itemVariants}
// //               whileHover={{
// //                 scale: 1.05,
// //                 boxShadow: "0 12px 32px rgba(255, 219, 77, 0.15)",
// //               }}
// //             >
// //               <h3 className="text-xl font-bold mb-1">{job.title}</h3>
// //               <p className="text-yellow-300 font-medium mb-1">
// //                 {job.location} <span className="mx-1">|</span> {job.type}
// //               </p>
// //               <p className="text-gray-300 mb-4 flex-grow">{job.description}</p>
// //               <a
// //                 href="#apply"
// //                 className="mt-auto inline-block font-semibold bg-yellow-400 text-blue-900 px-5 py-2 rounded hover:bg-yellow-300 transition w-fit"
// //               >
// //                 Apply Now
// //               </a>
// //             </motion.div>
// //           ))}
// //         </div>
// //       </motion.section>

// //       {/* Why Work With Us Section */}
// //       <section className="py-20 bg-blue-800">
// //         <div className="max-w-5xl mx-auto px-6">
// //           <h2 className="text-4xl font-bold text-yellow-400 mb-10 text-center font-serif">
// //             Why Choose Augere Conversion?
// //           </h2>

// //           <div className="grid md:grid-cols-2 gap-10 mb-16">
// //             <div className="bg-white bg-opacity-10 p-6 rounded-lg">
// //               <h3 className="text-xl font-bold text-yellow-300 mb-3">Remote-First Culture</h3>
// //               <p className="text-blue-100">Work from anywhere in the world that inspires you. Our global team collaborates across time zones to deliver cutting-edge B2B data solutions.</p>
// //             </div>
// //             <div className="bg-white bg-opacity-10 p-6 rounded-lg">
// //               <h3 className="text-xl font-bold text-yellow-300 mb-3">Global Impact</h3>
// //               <p className="text-blue-100">Influence decision-making for companies worldwide from your home office. Your work directly affects business outcomes across continents.</p>
// //             </div>
// //             <div className="bg-white bg-opacity-10 p-6 rounded-lg">
// //               <h3 className="text-xl font-bold text-yellow-300 mb-3">Innovation Without Borders</h3>
// //               <p className="text-blue-100">Collaborate with diverse talents across the globe. We bring together the best minds regardless of geographical constraints.</p>
// //             </div>
// //             <div className="bg-white bg-opacity-10 p-6 rounded-lg">
// //               <h3 className="text-xl font-bold text-yellow-300 mb-3">Work-Life Harmony</h3>
// //               <p className="text-blue-100">Enjoy the flexibility of remote work while making a significant impact. We value output over hours spent at a desk.</p>
// //             </div>
// //           </div>

// //           <h3 className="text-2xl font-bold text-yellow-300 mb-6 text-center">Our Remote Work Benefits</h3>
// //           <ul className="max-w-xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-y-6 gap-x-14 text-yellow-200 text-lg font-medium">
// //             {perks.map((perk, i) => (
// //               <li key={i} className="flex items-center justify-center">
// //                 <span className="mr-2 text-2xl">✔️</span> {perk}
// //               </li>
// //             ))}
// //           </ul>
// //         </div>
// //       </section>

// //       {/* Data Researcher Specific Section */}
// //       <section className="py-20 bg-indigo-900">
// //         <div className="max-w-4xl mx-auto px-6">
// //           <h2 className="text-4xl font-bold text-yellow-400 mb-10 text-center font-serif">
// //             Data Researcher Position
// //           </h2>
// //           <div className="bg-white bg-opacity-10 p-8 rounded-xl">
// //             <p className="text-blue-100 mb-6 text-lg">
// //               We're seeking passionate and skilled Data Researchers to join our global remote team.
// //               As a Data Researcher at Augere Conversion, you'll work with complex datasets from various
// //               sources to deliver insights that drive client success.
// //             </p>

// //             <h3 className="text-2xl font-bold text-yellow-300 mb-4">Requirements:</h3>
// //             <ul className="text-blue-100 mb-8 list-disc list-inside space-y-2">
// //               <li>Bachelor's degree in any stream</li>
// //               <li>2+ years of experience in data research or analysis will be an added advantage</li>
// //               <li>Proficiency in data manipulation tools and programming languages (e.g., SQL, Python, R)</li>
// //               <li>Strong analytical and problem-solving skills</li>
// //               <li>Excellent communication and virtual collaboration abilities</li>
// //               <li>Self-motivated with the ability to work independently in a remote environment</li>
// //               <li>Comfortable with flexible working hours to accommodate global team interactions</li>
// //             </ul>

// //             <div className="text-center">
// //               <a
// //                 href="#apply"
// //                 className="inline-block font-semibold bg-yellow-400 text-blue-900 px-6 py-3 rounded-lg hover:bg-yellow-300 transition text-lg"
// //               >
// //                 Apply for Data Researcher Position
// //               </a>
// //             </div>
// //           </div>
// //         </div>
// //       </section>

// //       {/* Application Workflow */}
// //       <section
// //         id="apply"
// //         className="max-w-6xl mx-auto py-20 px-6 text-center text-white"
// //       >
// //         <h2 className="text-4xl font-bold mb-12 font-serif">How to Apply</h2>
// //         <div className="max-w-3xl mx-auto grid grid-cols-1 sm:grid-cols-3 gap-12">
// //           <motion.div
// //             initial={{ opacity: 0, y: 40 }}
// //             whileInView={{ opacity: 1, y: 0 }}
// //             transition={{ duration: 0.5, delay: 0.1 }}
// //             className="bg-blue-700 rounded-xl p-6"
// //           >
// //             <span className="text-6xl mb-3 block">1</span>
// //             <h3 className="text-lg mb-1 font-semibold">Browse Jobs</h3>
// //             <p className="text-blue-300 text-base">
// //               See all current open roles and pick one that matches your
// //               expertise.
// //             </p>
// //           </motion.div>
// //           <motion.div
// //             initial={{ opacity: 0, y: 40 }}
// //             whileInView={{ opacity: 1, y: 0 }}
// //             transition={{ duration: 0.5, delay: 0.28 }}
// //             className="bg-blue-700 rounded-xl p-6"
// //           >
// //             <span className="text-6xl mb-3 block">2</span>
// //             <h3 className="text-lg mb-1 font-semibold">Send Your CV</h3>
// //             <p className="text-blue-300 text-base">
// //               Email us your updated resume describing your passion and skills.
// //             </p>
// //           </motion.div>
// //           <motion.div
// //             initial={{ opacity: 0, y: 40 }}
// //             whileInView={{ opacity: 1, y: 0 }}
// //             transition={{ duration: 0.5, delay: 0.42 }}
// //             className="bg-blue-700 rounded-xl p-6"
// //           >
// //             <span className="text-6xl mb-3 block">3</span>
// //             <h3 className="text-lg mb-1 font-semibold">Interview & Join</h3>
// //             <p className="text-blue-300 text-base">
// //               If shortlisted, attend interviews and join our global remote team!
// //             </p>
// //           </motion.div>
// //         </div>
// //       </section>

// //       {/* Employee Testimonials */}
// //       <section className="py-20 bg-gradient-to-b from-indigo-900 to-blue-900">
// //         <div className="max-w-6xl mx-auto px-6">
// //           <h2 className="text-4xl text-yellow-400 font-bold text-center font-serif mb-12">
// //             Employee Stories
// //           </h2>
// //           <div className="grid md:grid-cols-2 gap-10">
// //             {testimonials.map(({ name, role, photo, quote }, i) => (
// //               <motion.div
// //                 key={i}
// //                 initial={{ opacity: 0, y: 30 }}
// //                 whileInView={{ opacity: 1, y: 0 }}
// //                 transition={{ duration: 0.5, delay: i * 0.2 }}
// //                 className="bg-blue-800 bg-opacity-80 rounded-xl p-8 shadow-lg flex items-center gap-6"
// //               >
// //                 <img
// //                   src={photo}
// //                   alt={`${name}, ${role}`}
// //                   className="w-20 h-20 rounded-full object-cover border-4 border-yellow-400"
// //                 />
// //                 <div>
// //                   <p className="mb-3 italic text-blue-100">"{quote}"</p>
// //                   <p className="font-bold text-yellow-400">{name}</p>
// //                   <p className="text-blue-300">{role}</p>
// //                 </div>
// //               </motion.div>
// //             ))}
// //           </div>
// //         </div>
// //       </section>

// //       {/* CTA */}
// //       <section className="bg-yellow-400 py-16 text-blue-900 text-center font-bold text-xl tracking-wide">
// //         <p className="mb-4">Ready to join our global remote team?</p>
// //         <a href="mailto:careers@augereconversion.com" className="underline hover:text-yellow-600 transition">
// //           Email your CV to careers@augereconversion.com
// //         </a>
// //       </section>
// //     </div>
// //   );
// // };

// // export default Carreies;

// // import React from "react";
// // import { motion } from "framer-motion";

// // const jobs = [
// //   {
// //     id: 1,
// //     title: "Senior Data Analyst",
// //     location: "Mumbai/Pune, India (Remote)",
// //     type: "Full-time",
// //     description:
// //       "Leverage data to improve client sales strategies and campaign reach. Experience in BFSI or SaaS preferred.",
// //   },
// //   {
// //     id: 2,
// //     title: "Bilingual Telecalling Executive",
// //     location: "Mumbai/Pune, India (Remote)",
// //     type: "Contract",
// //     description:
// //       "Fluency in English and Hindi required. Handle outbound campaigns targeting Tier-1 & Tier-2 Indian metros.",
// //   },
// //   {
// //     id: 3,
// //     title: "Data Researcher",
// //     location: "Remote (India)",
// //     type: "Full-time",
// //     description:
// //       "Collect, analyze, and interpret complex datasets from various sources for our global client base.",
// //   },
// // ];

// // const perks = [
// //   "Competitive salary packages",
// //   "Remote-first work culture",
// //   "Home office setup allowance",
// //   "Global health and wellness programs",
// //   "Online professional development",
// //   "Flexible working hours",
// // ];

// // const testimonials = [
// //   {
// //     name: "Priya Sharma",
// //     role: "Lead Data Engineer",
// //     quote:
// //       "At Augere I get to work with data at Indian scale and see our impact directly on B2B client success.",
// //   },
// //   {
// //     name: "Rajesh Kumar",
// //     role: "Telecalling Team Lead",
// //     quote:
// //       "Supportive team, constant innovation, and flexible work-life balance—Augere truly values every employee.",
// //   },
// // ];

// // const containerVariants = {
// //   hidden: { opacity: 0 },
// //   visible: {
// //     opacity: 1,
// //     transition: { staggerChildren: 0.14, when: "beforeChildren" },
// //   },
// // };
// // const itemVariants = {
// //   hidden: { opacity: 0, y: 20 },
// //   visible: { opacity: 1, y: 0 },
// // };

// // const Carreies = () => {
// //   return (
// //     <div className="bg-gradient-to-b from-blue-900 to-indigo-950 min-h-screen text-white font-sans tracking-tight">
// //       {/* Hero Section */}
// //       <section className="relative bg-[url('https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=1470&q=80')] bg-cover bg-center min-h-[60vh] flex items-center justify-center px-6">
// //         <div className="bg-black bg-opacity-60 p-10 rounded-lg max-w-3xl text-center shadow-lg">
// //           <h1 className="text-5xl font-extrabold mb-5 font-serif drop-shadow-lg">
// //             Careers at Augere Conversion
// //           </h1>
// //           <p className="text-xl max-w-xl mx-auto text-blue-100 mb-6">
// //             Join the Global Data Revolution - From Anywhere. We're redefining
// //             the landscape of data-driven solutions through our innovative
// //             remote-first approach.
// //           </p>
// //           <a
// //             href="#openings"
// //             className="inline-block mt-2 px-7 py-3 bg-yellow-400 text-blue-900 font-bold rounded-md shadow-lg hover:bg-yellow-300 transition"
// //           >
// //             View Open Positions
// //           </a>
// //         </div>
// //       </section>

// //       {/* Open Jobs Section */}
// //       <motion.section
// //         id="openings"
// //         className="max-w-7xl mx-auto py-20 px-6"
// //         variants={containerVariants}
// //         initial="hidden"
// //         whileInView="visible"
// //         viewport={{ once: true }}
// //       >
// //         <h2 className="text-4xl font-bold text-yellow-400 mb-12 text-center font-serif">
// //           Open Positions
// //         </h2>
// //         <div className="grid md:grid-cols-3 gap-9">
// //           {jobs.map((job) => (
// //             <motion.div
// //               key={job.id}
// //               className="bg-white bg-opacity-10 backdrop-blur-xl rounded-xl p-7 flex flex-col shadow-md"
// //               variants={itemVariants}
// //               whileHover={{
// //                 scale: 1.05,
// //                 boxShadow: "0 12px 32px rgba(255, 219, 77, 0.15)",
// //               }}
// //             >
// //               <h3 className="text-xl font-bold mb-1">{job.title}</h3>
// //               <p className="text-yellow-300 font-medium mb-1">
// //                 {job.location} <span className="mx-1">|</span> {job.type}
// //               </p>
// //               <p className="text-gray-300 mb-4 flex-grow">{job.description}</p>
// //               <a
// //                 href="#apply"
// //                 className="mt-auto inline-block font-semibold bg-yellow-400 text-blue-900 px-5 py-2 rounded hover:bg-yellow-300 transition w-fit"
// //               >
// //                 Apply Now
// //               </a>
// //             </motion.div>
// //           ))}
// //         </div>
// //       </motion.section>

// //       {/* Why Work With Us Section */}
// //       <section className="py-20 bg-blue-800">
// //         <div className="max-w-5xl mx-auto px-6">
// //           <h2 className="text-4xl font-bold text-yellow-400 mb-10 text-center font-serif">
// //             Why Choose Augere Conversion?
// //           </h2>

// //           <div className="grid md:grid-cols-2 gap-10 mb-16">
// //             <div className="bg-white bg-opacity-10 p-6 rounded-lg">
// //               <h3 className="text-xl font-bold text-yellow-300 mb-3">
// //                 Remote-First Culture
// //               </h3>
// //               <p className="text-blue-100">
// //                 Work from anywhere in the world that inspires you. Our global
// //                 team collaborates across time zones to deliver cutting-edge B2B
// //                 data solutions.
// //               </p>
// //             </div>
// //             <div className="bg-white bg-opacity-10 p-6 rounded-lg">
// //               <h3 className="text-xl font-bold text-yellow-300 mb-3">
// //                 Global Impact
// //               </h3>
// //               <p className="text-blue-100">
// //                 Influence decision-making for companies worldwide from your home
// //                 office. Your work directly affects business outcomes across
// //                 continents.
// //               </p>
// //             </div>
// //             <div className="bg-white bg-opacity-10 p-6 rounded-lg">
// //               <h3 className="text-xl font-bold text-yellow-300 mb-3">
// //                 Innovation Without Borders
// //               </h3>
// //               <p className="text-blue-100">
// //                 Collaborate with diverse talents across the globe. We bring
// //                 together the best minds regardless of geographical constraints.
// //               </p>
// //             </div>
// //             <div className="bg-white bg-opacity-10 p-6 rounded-lg">
// //               <h3 className="text-xl font-bold text-yellow-300 mb-3">
// //                 Work-Life Harmony
// //               </h3>
// //               <p className="text-blue-100">
// //                 Enjoy the flexibility of remote work while making a significant
// //                 impact. We value output over hours spent at a desk.
// //               </p>
// //             </div>
// //           </div>

// //           <h3 className="text-2xl font-bold text-yellow-300 mb-6 text-center">
// //             Our Remote Work Benefits
// //           </h3>
// //           <ul className="max-w-xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-y-6 gap-x-14 text-yellow-200 text-lg font-medium">
// //             {perks.map((perk, i) => (
// //               <li key={i} className="flex items-center justify-center">
// //                 <span className="mr-2 text-2xl">✔️</span> {perk}
// //               </li>
// //             ))}
// //           </ul>
// //         </div>
// //       </section>

// //       {/* Data Researcher Specific Section */}
// //       <section className="py-20 bg-indigo-900">
// //         <div className="max-w-4xl mx-auto px-6">
// //           <h2 className="text-4xl font-bold text-yellow-400 mb-10 text-center font-serif">
// //             Data Researcher Position
// //           </h2>
// //           <div className="bg-white bg-opacity-10 p-8 rounded-xl">
// //             <p className="text-blue-100 mb-6 text-lg">
// //               We're seeking passionate and skilled Data Researchers to join our
// //               global remote team. As a Data Researcher at Augere Conversion,
// //               you'll work with complex datasets from various sources to deliver
// //               insights that drive client success.
// //             </p>

// //             <h3 className="text-2xl font-bold text-yellow-300 mb-4">
// //               Requirements:
// //             </h3>
// //             <ul className="text-blue-100 mb-8 list-disc list-inside space-y-2">
// //               <li>Bachelor's degree in any stream</li>
// //               <li>
// //                 2+ years of experience in data research or analysis will be an
// //                 added advantage
// //               </li>
// //               <li>
// //                 Proficiency in data manipulation tools and programming languages
// //                 (e.g., SQL, Python, R)
// //               </li>
// //               <li>Strong analytical and problem-solving skills</li>
// //               <li>
// //                 Excellent communication and virtual collaboration abilities
// //               </li>
// //               <li>
// //                 Self-motivated with the ability to work independently in a
// //                 remote environment
// //               </li>
// //               <li>
// //                 Comfortable with flexible working hours to accommodate global
// //                 team interactions
// //               </li>
// //             </ul>

// //             <div className="text-center">
// //               <a
// //                 href="#apply"
// //                 className="inline-block font-semibold bg-yellow-400 text-blue-900 px-6 py-3 rounded-lg hover:bg-yellow-300 transition text-lg"
// //               >
// //                 Apply for Data Researcher Position
// //               </a>
// //             </div>
// //           </div>
// //         </div>
// //       </section>

// //       {/* Application Workflow */}
// //       <section
// //         id="apply"
// //         className="max-w-6xl mx-auto py-20 px-6 text-center text-white"
// //       >
// //         <h2 className="text-4xl font-bold mb-12 font-serif">How to Apply</h2>
// //         <div className="max-w-3xl mx-auto grid grid-cols-1 sm:grid-cols-3 gap-12">
// //           <motion.div
// //             initial={{ opacity: 0, y: 40 }}
// //             whileInView={{ opacity: 1, y: 0 }}
// //             transition={{ duration: 0.5, delay: 0.1 }}
// //             className="bg-blue-700 rounded-xl p-6"
// //           >
// //             <span className="text-6xl mb-3 block">1</span>
// //             <h3 className="text-lg mb-1 font-semibold">Browse Jobs</h3>
// //             <p className="text-blue-300 text-base">
// //               See all current open roles and pick one that matches your
// //               expertise.
// //             </p>
// //           </motion.div>
// //           <motion.div
// //             initial={{ opacity: 0, y: 40 }}
// //             whileInView={{ opacity: 1, y: 0 }}
// //             transition={{ duration: 0.5, delay: 0.28 }}
// //             className="bg-blue-700 rounded-xl p-6"
// //           >
// //             <span className="text-6xl mb-3 block">2</span>
// //             <h3 className="text-lg mb-1 font-semibold">Send Your CV</h3>
// //             <p className="text-blue-300 text-base">
// //               Email us your updated resume describing your passion and skills.
// //             </p>
// //           </motion.div>
// //           <motion.div
// //             initial={{ opacity: 0, y: 40 }}
// //             whileInView={{ opacity: 1, y: 0 }}
// //             transition={{ duration: 0.5, delay: 0.42 }}
// //             className="bg-blue-700 rounded-xl p-6"
// //           >
// //             <span className="text-6xl mb-3 block">3</span>
// //             <h3 className="text-lg mb-1 font-semibold">Interview & Join</h3>
// //             <p className="text-blue-300 text-base">
// //               If shortlisted, attend interviews and join our global remote team!
// //             </p>
// //           </motion.div>
// //         </div>
// //       </section>

// //       {/* Employee Testimonials */}
// //       <section className="py-20 bg-gradient-to-b from-indigo-900 to-blue-900">
// //         <div className="max-w-6xl mx-auto px-6">
// //           <h2 className="text-4xl text-yellow-400 font-bold text-center font-serif mb-12">
// //             Employee Stories
// //           </h2>
// //           <div className="grid md:grid-cols-2 gap-10">
// //             {testimonials.map(({ name, role, quote }, i) => (
// //               <motion.div
// //                 key={i}
// //                 initial={{ opacity: 0, y: 30 }}
// //                 whileInView={{ opacity: 1, y: 0 }}
// //                 transition={{ duration: 0.5, delay: i * 0.2 }}
// //                 className="bg-blue-800 bg-opacity-80 rounded-xl p-8 shadow-lg"
// //               >
// //                 <div className="flex items-center mb-4">
// //                   <div className="w-16 h-16 rounded-full bg-yellow-400 flex items-center justify-center mr-4">
// //                     <span className="text-blue-900 text-2xl font-bold">
// //                       {name.charAt(0)}
// //                     </span>
// //                   </div>
// //                   <div>
// //                     <p className="font-bold text-yellow-400">{name}</p>
// //                     <p className="text-blue-300">{role}</p>
// //                   </div>
// //                 </div>
// //                 <p className="italic text-blue-100">"{quote}"</p>
// //               </motion.div>
// //             ))}
// //           </div>
// //         </div>
// //       </section>

// //       {/* CTA */}
// //       <section className="bg-yellow-400 py-16 text-blue-900 text-center font-bold text-xl tracking-wide">
// //         <p className="mb-4">Ready to join our global remote team?</p>
// //         <a
// //           href="mailto:careers@augere.co.in"
// //           className="underline hover:text-yellow-600 transition"
// //         >
// //           Email your CV to careers@augere.co.in
// //         </a>
// //       </section>
// //     </div>
// //   );
// // };

// // export default Carreies;

// import React from "react";
// import { motion } from "framer-motion";

// const jobs = [
//   {
//     id: 1,
//     title: "Senior Data Analyst",
//     location: "Mumbai/Pune, India (Remote)",
//     type: "Full-time",
//     description:
//       "Leverage data to improve client sales strategies and campaign reach. Experience in BFSI or SaaS preferred.",
//   },
//   {
//     id: 2,
//     title: "Bilingual Telecalling Executive",
//     location: "Mumbai/Pune, India (Remote)",
//     type: "Contract",
//     description:
//       "Fluency in English and Hindi required. Handle outbound campaigns targeting Tier-1 & Tier-2 Indian metros.",
//   },
//   {
//     id: 3,
//     title: "Data Researcher",
//     location: "Remote (India)",
//     type: "Full-time",
//     description:
//       "Collect, analyze, and interpret complex datasets from various sources for our global client base.",
//   },
// ];

// const perks = [
//   "Competitive salary packages",
//   "Remote-first work culture",
//   "Home office setup allowance",
//   "Global health and wellness programs",
//   "Online professional development",
//   "Flexible working hours",
// ];

// const testimonials = [
//   {
//     name: "Priya Sharma",
//     role: "Lead Data Engineer",
//     quote:
//       "At Augere I get to work with data at Indian scale and see our impact directly on B2B client success.",
//   },
//   {
//     name: "Rajesh Kumar",
//     role: "Telecalling Team Lead",
//     quote:
//       "Supportive team, constant innovation, and flexible work-life balance—Augere truly values every employee.",
//   },
// ];

// const containerVariants = {
//   hidden: { opacity: 0 },
//   visible: {
//     opacity: 1,
//     transition: { staggerChildren: 0.14, when: "beforeChildren" },
//   },
// };
// const itemVariants = {
//   hidden: { opacity: 0, y: 20 },
//   visible: { opacity: 1, y: 0 },
// };

// const Carreies = () => {
//   return (
//     <div className="bg-gradient-to-b from-blue-900 to-indigo-950 min-h-screen text-white font-sans tracking-tight">
//       {/* Hero Section */}
//       <section className="relative bg-[url('https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=1470&q=80')] bg-cover bg-center min-h-[60vh] flex items-center justify-center px-6">
//         <div className="bg-black bg-opacity-60 p-10 rounded-lg max-w-3xl text-center shadow-lg">
//           <h1 className="text-5xl font-extrabold mb-5 font-serif drop-shadow-lg">
//             Careers at Augere Conversion
//           </h1>
//           <p className="text-xl max-w-xl mx-auto text-blue-100 mb-6">
//             Join the Global Data Revolution - From Anywhere. We're redefining
//             the landscape of data-driven solutions through our innovative
//             remote-first approach.
//           </p>
//           <a
//             href="#openings"
//             className="inline-block mt-2 px-7 py-3 bg-yellow-400 text-blue-900 font-bold rounded-md shadow-lg hover:bg-yellow-300 transition"
//           >
//             View Open Positions
//           </a>
//         </div>
//       </section>

//       {/* Open Jobs Section */}
//       <motion.section
//         id="openings"
//         className="max-w-7xl mx-auto py-20 px-6"
//         variants={containerVariants}
//         initial="hidden"
//         whileInView="visible"
//         viewport={{ once: true }}
//       >
//         <h2 className="text-4xl font-bold text-yellow-400 mb-12 text-center font-serif">
//           Open Positions
//         </h2>
//         <div className="grid md:grid-cols-3 gap-9">
//           {jobs.map((job) => (
//             <motion.div
//               key={job.id}
//               className="bg-white bg-opacity-10 backdrop-blur-xl rounded-xl p-7 flex flex-col shadow-md"
//               variants={itemVariants}
//               whileHover={{
//                 scale: 1.05,
//                 boxShadow: "0 12px 32px rgba(255, 219, 77, 0.15)",
//               }}
//             >
//               <h3 className="text-xl font-bold mb-1">{job.title}</h3>
//               <p className="text-yellow-300 font-medium mb-1">
//                 {job.location} <span className="mx-1">|</span> {job.type}
//               </p>
//               <p className="text-gray-300 mb-4 flex-grow">{job.description}</p>
//               <a
//                 href="mailto:careers@augere.co.in"
//                 className="mt-auto inline-block font-semibold bg-yellow-400 text-blue-900 px-5 py-2 rounded hover:bg-yellow-300 transition w-fit"
//               >
//                 Apply Now
//               </a>
//             </motion.div>
//           ))}
//         </div>
//       </motion.section>

//       {/* Why Work With Us Section */}
//       <section className="py-20 bg-blue-800">
//         <div className="max-w-5xl mx-auto px-6">
//           <h2 className="text-4xl font-bold text-yellow-400 mb-10 text-center font-serif">
//             Why Choose Augere Conversion?
//           </h2>

//           <div className="grid md:grid-cols-2 gap-10 mb-16">
//             <div className="bg-white bg-opacity-10 p-6 rounded-lg">
//               <h3 className="text-xl font-bold text-yellow-300 mb-3">
//                 Remote-First Culture
//               </h3>
//               <p className="text-blue-100">
//                 Work from anywhere in the world that inspires you. Our global
//                 team collaborates across time zones to deliver cutting-edge B2B
//                 data solutions.
//               </p>
//             </div>
//             <div className="bg-white bg-opacity-10 p-6 rounded-lg">
//               <h3 className="text-xl font-bold text-yellow-300 mb-3">
//                 Global Impact
//               </h3>
//               <p className="text-blue-100">
//                 Influence decision-making for companies worldwide from your home
//                 office. Your work directly affects business outcomes across
//                 continents.
//               </p>
//             </div>
//             <div className="bg-white bg-opacity-10 p-6 rounded-lg">
//               <h3 className="text-xl font-bold text-yellow-300 mb-3">
//                 Innovation Without Borders
//               </h3>
//               <p className="text-blue-100">
//                 Collaborate with diverse talents across the globe. We bring
//                 together the best minds regardless of geographical constraints.
//               </p>
//             </div>
//             <div className="bg-white bg-opacity-10 p-6 rounded-lg">
//               <h3 className="text-xl font-bold text-yellow-300 mb-3">
//                 Work-Life Harmony
//               </h3>
//               <p className="text-blue-100">
//                 Enjoy the flexibility of remote work while making a significant
//                 impact. We value output over hours spent at a desk.
//               </p>
//             </div>
//           </div>

//           <h3 className="text-2xl font-bold text-yellow-300 mb-6 text-center">
//             Our Remote Work Benefits
//           </h3>
//           <ul className="max-w-xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-y-6 gap-x-14 text-yellow-200 text-lg font-medium">
//             {perks.map((perk, i) => (
//               <li key={i} className="flex items-center justify-center">
//                 <span className="mr-2 text-2xl">✔️</span> {perk}
//               </li>
//             ))}
//           </ul>
//         </div>
//       </section>

//       {/* Data Researcher Specific Section */}
//       <section className="py-20 bg-indigo-900">
//         <div className="max-w-4xl mx-auto px-6">
//           <h2 className="text-4xl font-bold text-yellow-400 mb-10 text-center font-serif">
//             Data Researcher Position
//           </h2>
//           <div className="bg-white bg-opacity-10 p-8 rounded-xl">
//             <p className="text-blue-100 mb-6 text-lg">
//               We're seeking passionate and skilled Data Researchers to join our
//               global remote team. As a Data Researcher at Augere Conversion,
//               you'll work with complex datasets from various sources to deliver
//               insights that drive client success.
//             </p>

//             <h3 className="text-2xl font-bold text-yellow-300 mb-4">
//               Requirements:
//             </h3>
//             <ul className="text-blue-100 mb-8 list-disc list-inside space-y-2">
//               <li>Bachelor's degree in any stream</li>
//               <li>
//                 2+ years of experience in data research or analysis will be an
//                 added advantage
//               </li>
//               <li>
//                 Proficiency in data manipulation tools and programming languages
//                 (e.g., SQL, Python, R)
//               </li>
//               <li>Strong analytical and problem-solving skills</li>
//               <li>
//                 Excellent communication and virtual collaboration abilities
//               </li>
//               <li>
//                 Self-motivated with the ability to work independently in a
//                 remote environment
//               </li>
//               <li>
//                 Comfortable with flexible working hours to accommodate global
//                 team interactions
//               </li>
//             </ul>

//             <div className="text-center">
//               <a
//                 href="mailto:careers@augere.co.in"
//                 className="inline-block font-semibold bg-yellow-400 text-blue-900 px-6 py-3 rounded-lg hover:bg-yellow-300 transition text-lg"
//               >
//                 Apply for Data Researcher Position
//               </a>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Application Workflow */}
//       <section
//         id="apply"
//         className="max-w-6xl mx-auto py-20 px-6 text-center text-white"
//       >
//         <h2 className="text-4xl font-bold mb-12 font-serif">How to Apply</h2>
//         <div className="max-w-3xl mx-auto grid grid-cols-1 sm:grid-cols-3 gap-12">
//           <motion.div
//             initial={{ opacity: 0, y: 40 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.5, delay: 0.1 }}
//             className="bg-blue-700 rounded-xl p-6"
//           >
//             <span className="text-6xl mb-3 block">1</span>
//             <h3 className="text-lg mb-1 font-semibold">Browse Jobs</h3>
//             <p className="text-blue-300 text-base">
//               See all current open roles and pick one that matches your
//               expertise.
//             </p>
//           </motion.div>
//           <motion.div
//             initial={{ opacity: 0, y: 40 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.5, delay: 0.28 }}
//             className="bg-blue-700 rounded-xl p-6"
//           >
//             <span className="text-6xl mb-3 block">2</span>
//             <h3 className="text-lg mb-1 font-semibold">Send Your CV</h3>
//             <p className="text-blue-300 text-base">
//               Email us your updated resume describing your passion and skills.
//             </p>
//           </motion.div>
//           <motion.div
//             initial={{ opacity: 0, y: 40 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.5, delay: 0.42 }}
//             className="bg-blue-700 rounded-xl p-6"
//           >
//             <span className="text-6xl mb-3 block">3</span>
//             <h3 className="text-lg mb-1 font-semibold">Interview & Join</h3>
//             <p className="text-blue-300 text-base">
//               If shortlisted, attend interviews and join our global remote team!
//             </p>
//           </motion.div>
//         </div>
//       </section>

//       {/* Employee Testimonials */}
//       <section className="py-20 bg-gradient-to-b from-indigo-900 to-blue-900">
//         <div className="max-w-6xl mx-auto px-6">
//           <h2 className="text-4xl text-yellow-400 font-bold text-center font-serif mb-12">
//             Employee Stories
//           </h2>
//           <div className="grid md:grid-cols-2 gap-10">
//             {testimonials.map(({ name, role, quote }, i) => (
//               <motion.div
//                 key={i}
//                 initial={{ opacity: 0, y: 30 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.5, delay: i * 0.2 }}
//                 className="bg-blue-800 bg-opacity-80 rounded-xl p-8 shadow-lg"
//               >
//                 <div className="flex items-center mb-4">
//                   <div className="w-16 h-16 rounded-full bg-yellow-400 flex items-center justify-center mr-4">
//                     <span className="text-blue-900 text-2xl font-bold">
//                       {name.charAt(0)}
//                     </span>
//                   </div>
//                   <div>
//                     <p className="font-bold text-yellow-400">{name}</p>
//                     <p className="text-blue-300">{role}</p>
//                   </div>
//                 </div>
//                 <p className="italic text-blue-100">"{quote}"</p>
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* CTA */}
//       <section className="bg-yellow-400 py-16 text-blue-900 text-center font-bold text-xl tracking-wide">
//         <p className="mb-4">Ready to join our global remote team?</p>
//         <a
//           href="mailto:careers@augere.co.in"
//           className="underline hover:text-yellow-600 transition"
//         >
//           Email your CV to careers@augere.co.in
//         </a>
//       </section>
//     </div>
//   );
// };

// export default Carreies;

import React from "react";
import { motion } from "framer-motion";

const jobs = [
  {
    id: 1,
    title: "Senior Data Analyst",
    location: "Mumbai/Pune, India (Remote)",
    type: "Full-time",
    description:
      "Leverage data to improve client sales strategies and campaign reach. Experience in BFSI or SaaS preferred.",
  },
  {
    id: 2,
    title: "Bilingual Telecalling Executive",
    location: "Mumbai/Pune, India (Remote)",
    type: "Contract",
    description:
      "Fluency in English and Hindi required. Handle outbound campaigns targeting Tier-1 & Tier-2 Indian metros.",
  },
  {
    id: 3,
    title: "Data Researcher",
    location: "Remote (India)",
    type: "Full-time",
    description:
      "Collect, analyze, and interpret complex datasets from various sources for our global client base.",
  },
];

const perks = [
  "Competitive salary packages",
  "Remote-first work culture",
  "Home office setup allowance",
  "Global health and wellness programs",
  "Online professional development",
  "Flexible working hours",
];

const testimonials = [
  {
    name: "Priya Sharma",
    role: "Lead Data Engineer",
    quote:
      "At Augere I get to work with data at Indian scale and see our impact directly on B2B client success.",
  },
  {
    name: "Rajesh Kumar",
    role: "Telecalling Team Lead",
    quote:
      "Supportive team, constant innovation, and flexible work-life balance—Augere truly values every employee.",
  },
];

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.14, when: "beforeChildren" },
  },
};
const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 },
};

const Carreies = () => {
  return (
    <div className="bg-gradient-to-b from-blue-900 to-indigo-950 min-h-screen text-white font-sans tracking-tight">
      {/* Hero Section */}
      <section className="relative bg-[url('https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=1470&q=80')] bg-cover bg-center min-h-[60vh] flex items-center justify-center px-6">
        <div className="bg-black bg-opacity-60 p-10 rounded-lg max-w-3xl text-center shadow-lg">
          <h1 className="text-5xl font-extrabold mb-5 font-serif drop-shadow-lg">
            Careers at Augere Conversion
          </h1>
          <p className="text-xl max-w-xl mx-auto text-blue-100 mb-6">
            Join the Global Data Revolution - From Anywhere. We're redefining
            the landscape of data-driven solutions through our innovative
            remote-first approach.
          </p>
          <a
            href="#openings"
            className="inline-block mt-2 px-7 py-3 bg-yellow-400 text-blue-900 font-bold rounded-md shadow-lg hover:bg-yellow-300 transition"
          >
            View Open Positions
          </a>
        </div>
      </section>

      {/* Open Jobs Section */}
      <motion.section
        id="openings"
        className="max-w-7xl mx-auto py-20 px-6"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        <h2 className="text-4xl font-bold text-yellow-400 mb-12 text-center font-serif">
          Open Positions
        </h2>
        <div className="grid md:grid-cols-3 gap-9">
          {jobs.map((job) => (
            <motion.div
              key={job.id}
              className="bg-white bg-opacity-10 backdrop-blur-xl rounded-xl p-7 flex flex-col shadow-md"
              variants={itemVariants}
              whileHover={{
                scale: 1.05,
                boxShadow: "0 12px 32px rgba(255, 219, 77, 0.15)",
              }}
            >
              <h3 className="text-xl font-bold mb-1">{job.title}</h3>
              <p className="text-yellow-300 font-medium mb-1">
                {job.location} <span className="mx-1">|</span> {job.type}
              </p>
              <p className="text-gray-300 mb-4 flex-grow">{job.description}</p>
              <a
                href="/contact"
                className="mt-auto inline-block font-semibold bg-yellow-400 text-blue-900 px-5 py-2 rounded hover:bg-yellow-300 transition w-fit"
              >
                Apply Now
              </a>
            </motion.div>
          ))}
        </div>
      </motion.section>

      {/* Why Work With Us Section */}
      <section className="py-20 bg-blue-800">
        <div className="max-w-5xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-yellow-400 mb-10 text-center font-serif">
            Why Choose Augere Conversion?
          </h2>

          <div className="grid md:grid-cols-2 gap-10 mb-16">
            <div className="bg-white bg-opacity-10 p-6 rounded-lg">
              <h3 className="text-xl font-bold text-yellow-300 mb-3">
                Remote-First Culture
              </h3>
              <p className="text-blue-100">
                Work from anywhere in the world that inspires you. Our global
                team collaborates across time zones to deliver cutting-edge B2B
                data solutions.
              </p>
            </div>
            <div className="bg-white bg-opacity-10 p-6 rounded-lg">
              <h3 className="text-xl font-bold text-yellow-300 mb-3">
                Global Impact
              </h3>
              <p className="text-blue-100">
                Influence decision-making for companies worldwide from your home
                office. Your work directly affects business outcomes across
                continents.
              </p>
            </div>
            <div className="bg-white bg-opacity-10 p-6 rounded-lg">
              <h3 className="text-xl font-bold text-yellow-300 mb-3">
                Innovation Without Borders
              </h3>
              <p className="text-blue-100">
                Collaborate with diverse talents across the globe. We bring
                together the best minds regardless of geographical constraints.
              </p>
            </div>
            <div className="bg-white bg-opacity-10 p-6 rounded-lg">
              <h3 className="text-xl font-bold text-yellow-300 mb-3">
                Work-Life Harmony
              </h3>
              <p className="text-blue-100">
                Enjoy the flexibility of remote work while making a significant
                impact. We value output over hours spent at a desk.
              </p>
            </div>
          </div>

          <h3 className="text-2xl font-bold text-yellow-300 mb-6 text-center">
            Our Remote Work Benefits
          </h3>
          <ul className="max-w-xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-y-6 gap-x-14 text-yellow-200 text-lg font-medium">
            {perks.map((perk, i) => (
              <li key={i} className="flex items-center justify-center">
                <span className="mr-2 text-2xl">✔️</span> {perk}
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* Data Researcher Specific Section */}
      <section className="py-20 bg-indigo-900">
        <div className="max-w-4xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-yellow-400 mb-10 text-center font-serif">
            Data Researcher Position
          </h2>
          <div className="bg-white bg-opacity-10 p-8 rounded-xl">
            <p className="text-blue-100 mb-6 text-lg">
              We're seeking passionate and skilled Data Researchers to join our
              global remote team. As a Data Researcher at Augere Conversion,
              you'll work with complex datasets from various sources to deliver
              insights that drive client success.
            </p>

            <h3 className="text-2xl font-bold text-yellow-300 mb-4">
              Requirements:
            </h3>
            <ul className="text-blue-100 mb-8 list-disc list-inside space-y-2">
              <li>Bachelor's degree in any stream</li>
              <li>
                2+ years of experience in data research or analysis will be an
                added advantage
              </li>
              <li>
                Proficiency in data manipulation tools and programming languages
                (e.g., SQL, Python, R)
              </li>
              <li>Strong analytical and problem-solving skills</li>
              <li>
                Excellent communication and virtual collaboration abilities
              </li>
              <li>
                Self-motivated with the ability to work independently in a
                remote environment
              </li>
              <li>
                Comfortable with flexible working hours to accommodate global
                team interactions
              </li>
            </ul>

            <div className="text-center">
              <a
                href="/contact"
                className="inline-block font-semibold bg-yellow-400 text-blue-900 px-6 py-3 rounded-lg hover:bg-yellow-300 transition text-lg"
              >
                Apply for Data Researcher Position
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Application Workflow */}
      <section
        id="apply"
        className="max-w-6xl mx-auto py-20 px-6 text-center text-white"
      >
        <h2 className="text-4xl font-bold mb-12 font-serif">How to Apply</h2>
        <div className="max-w-3xl mx-auto grid grid-cols-1 sm:grid-cols-3 gap-12">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="bg-blue-700 rounded-xl p-6"
          >
            <span className="text-6xl mb-3 block">1</span>
            <h3 className="text-lg mb-1 font-semibold">Browse Jobs</h3>
            <p className="text-blue-300 text-base">
              See all current open roles and pick one that matches your
              expertise.
            </p>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.28 }}
            className="bg-blue-700 rounded-xl p-6"
          >
            <span className="text-6xl mb-3 block">2</span>
            <h3 className="text-lg mb-1 font-semibold">Send Your CV</h3>
            <p className="text-blue-300 text-base">
              Email us your updated resume describing your passion and skills.
            </p>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.42 }}
            className="bg-blue-700 rounded-xl p-6"
          >
            <span className="text-6xl mb-3 block">3</span>
            <h3 className="text-lg mb-1 font-semibold">Interview & Join</h3>
            <p className="text-blue-300 text-base">
              If shortlisted, attend interviews and join our global remote team!
            </p>
          </motion.div>
        </div>
      </section>

      {/* Employee Testimonials */}
      <section className="py-20 bg-gradient-to-b from-indigo-900 to-blue-900">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-4xl text-yellow-400 font-bold text-center font-serif mb-12">
            Employee Stories
          </h2>
          <div className="grid md:grid-cols-2 gap-10">
            {testimonials.map(({ name, role, quote }, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: i * 0.2 }}
                className="bg-blue-800 bg-opacity-80 rounded-xl p-8 shadow-lg"
              >
                <div className="flex items-center mb-4">
                  <div className="w-16 h-16 rounded-full bg-yellow-400 flex items-center justify-center mr-4">
                    <span className="text-blue-900 text-2xl font-bold">
                      {name.charAt(0)}
                    </span>
                  </div>
                  <div>
                    <p className="font-bold text-yellow-400">{name}</p>
                    <p className="text-blue-300">{role}</p>
                  </div>
                </div>
                <p className="italic text-blue-100">"{quote}"</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-yellow-400 py-16 text-blue-900 text-center font-bold text-xl tracking-wide">
        <p className="mb-4">Ready to join our global remote team?</p>
        <a
          href="/contact"
          className="underline hover:text-yellow-600 transition"
        >
          Email your CV to careers@augere.co.in
        </a>
      </section>
    </div>
  );
};

export default Carreies;
